import React from 'react';

const Logo = ({ className = '', size = 120 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 200 200" 
      className={className}
      style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.3))' }}
    >
      {/* Transparent background - no fill */}
      
      {/* Tree trunk - brown with white stroke */}
      <path 
        d="M 85 140 L 85 95 Q 85 85 95 85 L 105 85 Q 115 85 115 95 L 115 140" 
        fill="#57534e" 
        stroke="white" 
        strokeWidth="3"
        strokeLinejoin="round"
      />
      
      {/* Main tree canopy - maroon with white stroke */}
      <circle 
        cx="100" 
        cy="70" 
        r="40" 
        fill="#7f1d1d" 
        stroke="white" 
        strokeWidth="3"
      />
      
      {/* Left branch foliage */}
      <circle 
        cx="65" 
        cy="85" 
        r="25" 
        fill="#8b2e2e" 
        stroke="white" 
        strokeWidth="3"
      />
      
      {/* Right branch foliage */}
      <circle 
        cx="135" 
        cy="85" 
        r="25" 
        fill="#8b2e2e" 
        stroke="white" 
        strokeWidth="3"
      />
      
      {/* Root system/ground */}
      <ellipse 
        cx="100" 
        cy="145" 
        rx="50" 
        ry="10" 
        fill="#57534e" 
        stroke="white" 
        strokeWidth="2.5"
        opacity="0.8"
      />
      
      {/* "ROOTED" text - white fill with dark stroke for visibility */}
      <text 
        x="100" 
        y="178" 
        fontSize="28" 
        fontWeight="900" 
        textAnchor="middle" 
        fill="white"
        stroke="#1a1a1a" 
        strokeWidth="1"
        fontFamily="Arial, sans-serif"
        letterSpacing="2"
      >
        ROOTED
      </text>
    </svg>
  );
};

export default Logo;